import React from "react";
import { Search } from "lucide-react";
import { cn } from "../../lib/utils";
import type { PortalShellSearchTriggerProps } from "../../contracts/portal-shell";

export function PortalShellSearchTrigger({
  value,
  placeholder = "Search...",
  shortcutLabel = "⌘K",
  ariaLabel = "Search",
  variant = "inline",
  disabled = false,
  onActivate,
  className,
}: PortalShellSearchTriggerProps) {
  if (variant === "icon") {
    return (
      <button
        type="button"
        onClick={onActivate}
        disabled={disabled}
        aria-label={ariaLabel}
        className={cn(
          "inline-flex h-9 w-9 items-center justify-center rounded-control text-muted-foreground transition-colors hover:bg-muted hover:text-foreground",
          disabled && "opacity-50 cursor-not-allowed",
          className
        )}
      >
        <Search className="h-4 w-4" />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onActivate}
      disabled={disabled}
      aria-label={ariaLabel}
      className={cn(
        "relative flex h-9 w-full items-center justify-between rounded-control border border-border bg-background px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-muted/50 focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
    >
      <div className="flex items-center gap-2 overflow-hidden">
        <Search className="h-4 w-4 shrink-0" />
        <span className="truncate">{value || placeholder}</span>
      </div>
      {shortcutLabel && (
        <kbd className="pointer-events-none hidden h-5 select-none items-center gap-1 rounded border border-border bg-muted px-1.5 font-mono text-[10px] font-medium opacity-100 sm:flex">
          {shortcutLabel}
        </kbd>
      )}
    </button>
  );
}
